import React, { useState } from "react";

function CampaignBuilder() {
  const [campaignName, setCampaignName] = useState("");
  const [campaignAudience, setCampaignAudience] = useState("");
  const [campaignOffer, setCampaignOffer] = useState("Free 3-point digital presence audit");

  const generatedCampaign = `Campaign Name: ${campaignName || "[Campaign Name]"}
Audience: ${campaignAudience || "[Target audience]"}
Offer: ${campaignOffer || "[Offer]"}

Message:
Hi [Name], I hope you are well.

My name is [YOUR NAME] from ProCode ZA. We help South African businesses improve how customers find, understand and contact them online.

We are currently reaching out to ${campaignAudience || "[target businesses]"} with an offer for a ${campaignOffer || "[offer]"}.

Our starter website solutions can begin from as little as R500, depending on the scope and requirements.

Would you be open to me sending through a free 3-point audit for your business?`;

  const copyCampaign = async () => {
    try {
      await navigator.clipboard.writeText(generatedCampaign);
      alert("Campaign copied.");
    } catch {
      alert("Could not copy campaign.");
    }
  };

  return (
    <section className="procrm-panel crm-section">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">Campaign Builder</span>
          <h2>Create campaign message</h2>
        </div>
      </div>

      <div className="campaign-builder">
        <label>
          Campaign Name
          <input
            value={campaignName}
            onChange={(event) => setCampaignName(event.target.value)}
            placeholder="e.g. Cape Town Beauty Website Push"
          />
        </label>

        <label>
          Target Audience
          <input
            value={campaignAudience}
            onChange={(event) => setCampaignAudience(event.target.value)}
            placeholder="e.g. beauty salons in Cape Town"
          />
        </label>

        <label>
          Offer
          <input
            value={campaignOffer}
            onChange={(event) => setCampaignOffer(event.target.value)}
          />
        </label>

        <textarea className="script-box campaign-output" value={generatedCampaign} readOnly />

        <button className="procrm-btn-primary" onClick={copyCampaign}>
          Copy Campaign
        </button>
      </div>
    </section>
  );
}

export default CampaignBuilder;